import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, collection, setDoc, updateDoc, query, orderBy, getDocs } from 'firebase/firestore';
import PropTypes from 'prop-types'
import React, { PureComponent, useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Button from '../components/forms/Button';
import CreateTask from '../components/task/CreateTask';
import ListTask from '../components/task/ListTask';
import UpdateTask from '../components/task/UpdateTask';
import { AuthContext } from '../context/auth';
import { TaskContext } from '../context/task';
import { firebaseConfig } from '../firebaseConfig';
import logo from '../img/kOnzy.gif';

export default function Tasks() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    


  
    const findTask =async () => {
      
        try {
            const TaskRef = doc(db, "cities", "DC");

            // Set the "capital" field of the city 'DC'
            await updateDoc(TaskRef, {
            capital: true
            });
        } catch (error) {
            toast.error("error"+error.message)
        }
        
    }
    
    

    
    return (
        <>
      <CreateTask/>
        <ListTask/>
        <UpdateTask/>
        </>
    )

}
